import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CarService, Car, ExcelPrintTarget, PdfPrintTarget } from './car.service';
import { UserService, Driver } from './user.service';
import { CommonService, Code } from '../app.service';
import { AppConstants, CODE, LOGON_INFO, COMP_TYPE, DATEPICKER, SERVER } from '../app.constants';
import $ from 'jquery';
import { MessageService } from '../common/message.service';
import { Company, CompanyService } from './company.service';
import { IMyDateModel, INgxMyDpOptions } from 'ngx-mydatepicker';
import ImageResize from 'image-resize';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as ClipBoard from 'clipboard';

import * as XLSX from 'xlsx-js-style';

@Component({
    selector: 'car-info',
    templateUrl: 'car.component.html',
    providers: [CarService, UserService, CompanyService]
})
export class CarComponent implements OnInit, OnDestroy {

    // @ViewChild(NgForm) f: NgForm;
    @ViewChild('f') f: NgForm;

    CONST: any = AppConstants;
    BASE_URL: string = SERVER.baseURL;

    // (202403)
    logon_id: string = LOGON_INFO.USER_ID;

    carList: Car[];
    searchCarList: Car[];
    driverList: Driver[];
    targetDriverList: Driver[] = [];
    currentCar: Car;

    comboDriverList: Driver[] = [];

    carTypeCodeList: Code[];
    carMakerCodeList: Code[];
    carRegistYearList: Code[];
    branchList: Company[] = [];

    licenseList: Code[];

    currPage: number;
    totalCount: number;
    PAGE_SIZE: number = 500;

    isLeaveCarPage: boolean;

    myDatePickerOptions: INgxMyDpOptions = DATEPICKER.myDatePickerOptions;
    myDatePickerOptions_noDisableUntil: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    search_comp_id: string = "";
    search_car_type: string = "";
    search_car_maker: string = "";
    search_car_regist_year: string = "";
    search_driver_exist: string = "";

    today: Date;

    printTarget: ExcelPrintTarget;
    photoPreviewEmptyCnt: number = 0;
    checkbox_toggle_all: boolean = false;
    file_preview_url: SafeUrl = undefined;

    // (2023.08)
    search_category: string = "";
    search_word: string = "";

    // (2023.09)
    pdfTarget: PdfPrintTarget;

    // (2023.11)セレクトボックスの絞り込み
    scaledCarTypeCodeList: Code[];
    scaledCarMakerCodeList: Code[];
    scaledCarRegistYearList: Code[];
    scaledBranchList: Company[] = [];

    // (2024.02)マルチセレクト対応
    selectedCheckList: any[];
    selectedCategory: string = "";
    selectedBranch: string = "";
    selectedRegistYear: string = "";
    selectedCarMaker: string = "";
    selectedCarType: string = "";
    showBranch: boolean = false;
    showRegistYear: boolean = false;
    showCarMaker: boolean = false;
    showCarType: boolean = false;
    existDriverList: Code[];
    scaledExistDriverList: Code[];
    selectedExistDriver: string ="";
    showExistDriver: boolean = false;

    // (2024.04)メニュー項目選択
    carMenuList: Code[];
    scaledCarMenuList: Code[];
    isShowCheckbox: boolean = true;
    selectedCheckbox: boolean = false;
    menuCheckList: any[];
    isFirstMenuOpen: boolean = true;
    isFirstSearchMap: any = { "所属": true, "車種": true, "車名": true, "年式": true, "有無": true };

    // (2026.04) キャンセル時の復元用状態保存配列
    savedSelectionState: boolean[] = [];

    printWindow: any;
    image: any;

    originBody: any;

    // (2024.05)ダウンロードリンク生成
    pdfLinkList: any[];
    linkCount: number = 0;

    newFileName: string = "";

    constructor(
        public commonService: CommonService,
        public carService: CarService,
        public userService: UserService,
        public messageService: MessageService,
        public companyService: CompanyService,
        private router: Router,
        public sanitizer: DomSanitizer,
        private deviceService: DeviceDetectorService
    ) {   }


    ngOnInit() {
        this.scaledCarTypeCodeList = this.carTypeCodeList = CODE.CAR_TYPE;
        this.scaledCarMakerCodeList = this.carMakerCodeList = CODE.CAR_MAKER;
        // (2024.04)メニュー項目選択
        this.scaledCarMenuList = this.carMenuList = CODE.CAR_MENU;
        // this.scaledCarMenuList.forEach((cm:any) => cm.is_selected = true);

        this.printTarget = new ExcelPrintTarget();
        this.today = new Date();
        this.isLeaveCarPage = this.router.url.indexOf('leave') > -1;
        this.currPage = 1;

        this.getBranchList();

        //車両登録年度リストを取得（combobox用）
        this.scaledCarRegistYearList = this.carRegistYearList = this.carService.getCarRegistYearList();

        this.licenseList = CODE.LICENSE_TYPE;

        this.refreshPage();

        // (2023.09)
        this.pdfTarget = new PdfPrintTarget();

        // (2024.02)マルチセレクト対応（ドライバー有無）
        this.existDriverList = this.scaledExistDriverList = [
            {code:"0", name:"無し", is_selected:false},
            {code:"1", name:"有り", is_selected:false},
            {code:"2", name:"予備", is_selected:false}
        ]
    }


    /**
     * ドライバーリスト取得（combobox用）
     */
    getDriverList() {
        this.userService.getDriverList(1, false, true)
            .subscribe(
                data => {
                    this.driverList = data['results'];
                    this.targetDriverList = this.driverList;
                }
            );
    }


    /**
     * 車両リスト取得
     */
    async getCarList() {
        //削除車両リストの場合
        if (this.isLeaveCarPage) {
            this.carService.getAllBranchCarList(this.currPage, true)
            .subscribe(
                data => {
                    this.carList = [];
                    this.carRegistYearList = [];
                    this.carService.convertCarInfo(data['results'], this.carList, this.carRegistYearList);
                    this.changeDateFormat();
                    // (2026.04) 初期データロード時に、実在する車両の項目のみを抽出してフィルタリストを初期化する
                    this.initScaledFilterLists();
                    this.getSearchCarList();
                }
            )
        }
        else {
            await this.carService.fetchAllCarList();
            this.carList = this.carService.getAllCarList();
            this.changeDateFormat();
            // (2026.04) 初期データロード時に、実在する車両の項目のみを抽出してフィルタリストを初期化する
            this.initScaledFilterLists();
            this.getSearchCarList();
        }
    }


    /**
     * (2026.04) 初期データロード時に、実在する車両の項目のみを抽出してフィルタリストを初期化する
     * システム全体のマスタデータから、現在の運用データ（carList）に存在する項目のみを動的に抽出・整列させる。
     */
    initScaledFilterLists() {
        const jaSort = (a: any, b: any) => (a.name || "").localeCompare(b.name || "", 'ja-JP');

        // 実在するデータのみで構成
        this.scaledBranchList = this.branchList.filter(cp => this.carList.some(e => e.comp_id == cp.comp_id));
        this.scaledCarMakerCodeList = this.carMakerCodeList.filter(cd => this.carList.some(e => e.car_maker == cd.code));
        this.scaledCarTypeCodeList = this.carTypeCodeList.filter(cd => this.carList.some(e => e.car_type == cd.code));
        this.scaledCarRegistYearList = this.carRegistYearList.filter(cd => this.carList.some(e => e.regist_ym && e.regist_ym.indexOf(cd.code) >= 0));
        this.scaledExistDriverList = this.existDriverList.filter(cd => this.carList.some(e => {
            if (cd.code == "0" && (!e.driver_id)) return true;
            if (cd.code == "1" && (e.driver_id && e.driver_name != "予備")) return true;
            if (cd.code == "2" && (e.driver_id && e.driver_name == "予備")) return true;
            return false;
        }));
        
        // (2026.04) 日本語辞書順（あいうえお順）にソートを行い、項目の位置を固定する
        this.scaledBranchList.sort(jaSort);
        this.scaledCarMakerCodeList.sort(jaSort);
        this.scaledCarTypeCodeList.sort(jaSort);
        this.scaledExistDriverList.sort(jaSort);
        // (2026.04) 年式は既存の時系列順（年度順）を維持するためソートを行わない
    }


    /**
     * 車両情報の各日付をdatepicker用に変換
     * @param carList
     */
    changeDateFormat(): void {
        for (var i=0; i<this.carList.length; i++) {
            let c: Car = this.carList[i];
            if (c.placement_date) {
                let sd = new Date(c.placement_date);
                c.placement_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.inspection_expire_date) {
                let sd = new Date(c.inspection_expire_date);
                c.inspection_expire_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.insurance_expire_date) {
                let sd = new Date(c.insurance_expire_date);
                c.insurance_expire_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.lease_date) {
                let sd = new Date(c.lease_date);
                c.lease_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
            if (c.lease_start_date) {
                let sd = new Date(c.lease_start_date);
                c.lease_start_date = { jsdate: sd, formatted: this.commonService.convertDate(sd, 'yyyy/MM/dd') };
            }
        }
    }


    /**
     * 車両リストの絞り込み
     */
    getSearchCarList() {
        this.searchCarList = this.carList.filter((e:Car) => {
            return (
                (!this.search_comp_id || e.comp_id == this.search_comp_id)
                &&
                (!this.search_car_type || e.car_type == this.search_car_type)
                &&
                (!this.search_car_maker || e.car_maker == this.search_car_maker)
                &&
                (!this.search_car_regist_year || e.regist_ym.indexOf(this.search_car_regist_year) >= 0)
                &&
                (!this.search_driver_exist || (this.search_driver_exist == '1' && e.driver_id) || (this.search_driver_exist == '0' && !e.driver_id) || (this.search_driver_exist == '2' && "予備" == e.driver_name))
            )
        });

        this.totalCount = this.searchCarList.length;
        this.search_category = "";
        this.search_word = "";
        // this.showBranch = this.showRegistYear = this.showCarMaker = this.showCarType = false;

        // (2023.11)
        if (this.searchCarList != this.carList) {
            // 検索項目全部「全て」の場合、初期化
            if (!this.search_comp_id && !this.search_car_type && !this.search_car_maker && !this.search_car_regist_year && !this.search_driver_exist)   return this.clearSearchItem();
        }

        // (2024.02)
        // if(this.search_comp_id) {
        //     this.selectedBranch = "所属：" + this.scaledBranchList[0].name;
        //     $('#searchInput .branch-select').text('-- 全て --');
        // }
        // if(this.search_car_type) {
        //     this.selectedCarType = "所属：" + this.scaledCarTypeCodeList[0].name;
        //     $('#searchInput .carType-select').text('-- 全て --');
        // }
        // if(this.search_car_maker) {
        //     this.selectedCarMaker = "所属：" + this.scaledCarMakerCodeList[0].name;
        //     $('#searchInput .maker-select').text('-- 全て --');
        // }
        // if(this.search_car_regist_year) {
        //     this.selectedRegistYear = "所属：" + this.scaledCarRegistYearList[0].name;
        //     $('#searchInput .year-select').text('-- 全て --');
        // }

        // this.showBranch = this.selectedBranch ? true : false;
        // this.showCarType = this.selectedCarType ? true : false;
        // this.showCarMaker = this.selectedCarMaker ? true : false;
        // this.showRegistYear = this.selectedRegistYear ? true : false;
    }


    /**
     * (2024.02) 複数条件による車両リストの絞り込み
     * (2026.04) ファセット検索ロジック
     * 
     * 【動作原理】
     * 1. ユーザーが選択した各カテゴリー（所属、車種等）の条件を抽出し、現在の絞り込み状態を更新します。
     * 2. 全車両データ（this.carList）に対して、有効なすべてのフィルタを同時に適用して表示リスト（searchCarList）を作成します。
     * 3. 各モーダルの選択肢（scaled*List）を再計算する際は、「自分自身の条件を除いた他カテゴリーの条件」を適用します。
     *    これにより、選択した項目以外が消失するのを防ぎつつ、他カテゴリーとの連動性（存在するデータのみ表示）を維持します。
     * 4. 選択項目が0個の場合は、そのカテゴリーのフィルタを解除（全選択状態）として扱います。
     */
    getMultiSearchCarList() {
        // (2026.04) 現在のモーダルで選択されている項目を取得
        const testList = this.selectedCheckList.filter((cd:Code) => cd.is_selected == true);

        // (2026.04) カテゴリーごとに、選択状態に応じて表示ラベルとフラグを更新
        // 選択がない（0個）場合は、フィルタ解除（初期状態）として処理する
        if(this.selectedCategory == "所属") {
            if (testList.length == 0) {
                this.selectedBranch = "";
                this.showBranch = false;
            } else if (testList.length == this.selectedCheckList.length) {
                this.selectedBranch = "所属：全体選択";
                this.showBranch = true;
            } else {
                this.selectedBranch = "所属：" + testList.map((l: any) => l.name).join();
                this.showBranch = true;
            }
        } else if(this.selectedCategory == "車種") {
            if (testList.length == 0) {
                this.selectedCarType = "";
                this.showCarType = false;
            } else if (testList.length == this.selectedCheckList.length) {
                this.selectedCarType = "車種：全体選択";
                this.showCarType = true;
            } else {
                this.selectedCarType = "車種：" + testList.map((l: any) => l.name).join();
                this.showCarType = true;
            }
        } else if(this.selectedCategory == "車名") {
            if (testList.length == 0) {
                this.selectedCarMaker = "";
                this.showCarMaker = false;
            } else if (testList.length == this.selectedCheckList.length) {
                this.selectedCarMaker = "車名：全体選択";
                this.showCarMaker = true;
            } else {
                this.selectedCarMaker = "車名：" + testList.map((l: any) => l.name).join();
                this.showCarMaker = true;
            }
        } else if(this.selectedCategory == "年式") {
            if (testList.length == 0) {
                this.selectedRegistYear = "";
                this.showRegistYear = false;
            } else if (testList.length == this.selectedCheckList.length) {
                this.selectedRegistYear = "年式：全体選択";
                this.showRegistYear = true;
            } else {
                this.selectedRegistYear = "年式：" + testList.map((l: any) => l.name).join();
                this.showRegistYear = true;
            }
        } else if(this.selectedCategory == "有無") {
            if (testList.length == 0) {
                this.selectedExistDriver = "";
                this.showExistDriver = false;
            } else if (testList.length == this.selectedCheckList.length) {
                this.selectedExistDriver = "ドライバー有無：全体選択";
                this.showExistDriver = true;
            } else {
                this.selectedExistDriver = "ドライバー有無：" + testList.map((l: any) => l.name).join();
                this.showExistDriver = true;
            }
        }

        // (2026.04) 各カテゴリーで選択されているコード値等のリストを作成
        const branchIds = this.showBranch ? this.branchList.filter((l: any) => l.is_selected).map((l: any) => l.comp_id) : null;
        const typeCodes = this.showCarType ? this.carTypeCodeList.filter((l: any) => l.is_selected).map((l: any) => l.code) : null;
        const makerCodes = this.showCarMaker ? this.carMakerCodeList.filter((l: any) => l.is_selected).map((l: any) => l.code) : null;
        const yearNames = this.showRegistYear ? this.carRegistYearList.filter((l: any) => l.is_selected).map((l: any) => l.name) : null;
        const driverCodes = this.showExistDriver ? this.existDriverList.filter((l: any) => l.is_selected).map((l: any) => l.code) : null;

        // (2026.04) 各フィルタの判定関数を定義
        const passBranch = (e: Car) => !branchIds || branchIds.includes(e.comp_id);
        const passType = (e: Car) => !typeCodes || typeCodes.includes(e.car_type);
        const passMaker = (e: Car) => !makerCodes || makerCodes.includes(e.car_maker);
        const passYear = (e: Car) => !yearNames || yearNames.some((name: string) => e.regist_ym && e.regist_ym.indexOf(name) >= 0);
        const passDriver = (e: Car) => {
            if (!driverCodes) return true;
            if (driverCodes.includes("0") && (!e.driver_id)) return true;
            if (driverCodes.includes("1") && (e.driver_id && e.driver_name != "予備")) return true;
            if (driverCodes.includes("2") && (e.driver_id && e.driver_name == "予備")) return true;
            return false;
        };

        // (2026.04) --- メインテーブルの更新 ---
        // すべての有効な条件を満たす車両のみを抽出
        this.searchCarList = this.carList.filter((e: Car) => 
            passBranch(e) && passType(e) && passMaker(e) && passYear(e) && passDriver(e)
        );

        this.totalCount = this.searchCarList.length;
        this.search_category = "";
        this.search_word = "";

        // (2026.04) --- 各モーダル内の選択肢（ scaled*List ）の動的更新 ---
        // (仕様変更により、検索後に他カテゴリーの項目を隠すクロスフィルタリングは廃止されました。
        // 初期ローディング時に構成されたリストをそのまま一貫して表示します。)

        // (2026.04) 初回検索フラグを下ろし、モーダルを閉じる
        this.isFirstSearchMap[this.selectedCategory] = false;
        $('#carMultiSelectModal').modal('hide');
    }


    /**
     * (2023.08)単語検索の絞り込み
     */
    getSearchWordCar() {
        // Type_1（全体検索）
        // this.searchCarList = this.carList.filter((w:Car) => {
        //     return (
        //         (w.comp_name == null ? false : w.comp_name.includes(this.search_word))
        //         ||
        //         (w.car_no == null ? false : w.car_no.includes(this.search_word))
        //         ||
        //         (w.car_type_name == null ? false : w.car_type_name.includes(this.search_word))
        //         ||
        //         (w.model_no == null ? false : w.model_no.includes(this.search_word))
        //         ||
        //         (w.body_no == null ? false : w.body_no.includes(this.search_word))
        //         ||
        //         (w.car_maker_name == null ? false : w.car_maker_name.includes(this.search_word))
        //         ||
        //         (w.owner == null ? false : w.owner.includes(this.search_word))
        //         ||
        //         (w.driver_name == null ? false : w.driver_name.includes(this.search_word))
        //     )
        // });

        // Type_2（カテゴリサーチ）
        this.searchCarList = this.carList.filter((w:Car) => {
            // if (this.search_category == '0')    return w.car_no == null ? false : w.car_no.includes(this.search_word.trim());
            if (this.search_category == '1')    return w.car_type_name == null ? false : w.car_type_name.includes(this.search_word.trim());
            if (this.search_category == '2')    return w.comp_name == null ? false : w.comp_name.includes(this.search_word.trim());
            if (this.search_category == '3')    return w.driver_name == null ? false : w.driver_name.includes(this.search_word.trim());

            // (2024.06)過去車両番号の検索追加
            if (this.search_category == '0') {
                if (w.car_no.includes(this.search_word.trim()))                         return true;

                // 値がある場合のみ探す
                if (w.inspection_pdf) {
                    if (w.inspection_pdf.includes(this.search_word.trim()))             return true;
                }
                if (w.inspection_license_pdf) {
                    if (w.inspection_license_pdf.includes(this.search_word.trim()))     return true;
                }
                if (w.insurance_pdf) {
                    if (w.insurance_pdf.includes(this.search_word.trim()))              return true;
                }
                if (w.insurance_option_pdf) {
                    if (w.insurance_option_pdf.includes(this.search_word.trim()))       return true;
                }
                if (w.weight_check_pdf) {
                    if (w.weight_check_pdf.includes(this.search_word.trim()))           return true;
                }
            }
        });
        this.totalCount = this.searchCarList.length;

        this.search_comp_id = this.search_car_type = this.search_car_maker = this.search_car_regist_year = this.search_driver_exist = "";

        // (2024.02)マルチセレクト対応
        this.selectedBranch = this.selectedRegistYear = this.selectedCarMaker = this.selectedCarType = this.selectedExistDriver = "";
        this.showBranch = this.showRegistYear = this.showCarMaker = this.showCarType = this.showExistDriver = false;
        // $('#searchInput .branch-select').text('-- 全て --');
        // $('#searchInput .carType-select').text('-- 全て --');
        // $('#searchInput .maker-select').text('-- 全て --');
        // $('#searchInput .year-select').text('-- 全て --');
    }

    /**
     * 絞り込み項目のクリア
     */
    clearSearchItem() {
        this.search_comp_id = "";
        this.search_car_type = "";
        this.search_car_maker = "";
        this.search_car_regist_year = "";
        this.search_driver_exist = "";
        this.searchCarList = this.carList;
        this.totalCount = this.searchCarList.length;

        this.checkbox_toggle_all = false;
        this.carList.forEach((c: Car) => {
            c.is_print_target = false;
        });

        this.search_category = "";
        this.search_word = "";

        // (2026.04) 既存のマスター生データ（実在しない項目を含む）へのリセット処理を廃止。
        // 代わりに、実在するデータのみを動的にスキャン・整列させる初期化関数（initScaledFilterLists）を呼び出す。
        // これにより、検索条件クリア後も正確なフィルタ項目のみを表示する。
        this.initScaledFilterLists();
        

        this.selectedBranch = this.selectedRegistYear = this.selectedCarMaker = this.selectedCarType = this.selectedExistDriver = "";
        this.showBranch = this.showRegistYear = this.showCarMaker = this.showCarType = this.showExistDriver = false;
        // $('#searchInput .branch-select').text('-- 全て --');
        // $('#searchInput .carType-select').text('-- 全て --');
        // $('#searchInput .maker-select').text('-- 全て --');
        // $('#searchInput .year-select').text('-- 全て --');

        this.scaledCarMenuList = this.carMenuList;
        this.isShowCheckbox = true;

        // (2024.04)
        this.isFirstMenuOpen = true;
        this.isFirstSearchMap = { "所属": true, "車種": true, "車名": true, "年式": true, "有無": true };
    }

    //ページ移動
    pageChange(page: number) {
        this.currPage = page;
        this.getCarList();
    }


    toggleCheckboxAll() {
        this.checkbox_toggle_all = !this.checkbox_toggle_all;
        this.searchCarList.forEach((c: Car) => {
            c.is_print_target = this.checkbox_toggle_all;
        });
    }

    // (2024.02)マルチセレクト対応（選択解除）
    toggleCheckboxFalse() {
        this.selectedCheckList.forEach((c: any) => {
            c.is_selected = false;
        });
    }

    /**
     * (2024.06)マルチセレクト対応（全選択）
     */
    selectAllCheckList() {
        this.selectedCheckList.forEach((c: any) => {
            c.is_selected = true;
        });
    }

    /**
     * (2026.04) menuMultiSelectModal内の選択をすべてクリアする
     */
    clearMenuCheckList() {
        this.menuCheckList.forEach((c: any) => {
            c.is_selected = false;
        });
    }

    selectAllMenuCheckList() {
        this.menuCheckList.forEach((c: any) => {
            c.is_selected = true;
        });
    }

    isAllSelected(checkList: any[]): boolean {
        if (!checkList || checkList.length === 0) return false;
        return checkList.every((item: any) => item.is_selected);
    }

    toggleMenuSelection(menu: any) {
        if (this.isAllSelected(this.menuCheckList)) {
            this.menuCheckList.forEach((c: any) => {
                c.is_selected = (c === menu);
            });
        } else {
            menu.is_selected = !menu.is_selected;
        }
    }

    /**
     * (2026.04) キャンセルボタンクリック時、以前の状態を復元
     */
    restoreCheckboxState() {
        if (this.savedSelectionState && this.savedSelectionState.length === this.selectedCheckList.length) {
            this.selectedCheckList.forEach((c: any, index: number) => {
                c.is_selected = this.savedSelectionState[index];
            });
        }
    }

    /**
     * (2024.04)メニュー項目選択
     */
    getMultiSearchMenuList() {
        // (2026.04) クリアした（選択0件）状態で検索した場合、全項目を表示（全選択状態）にする
        const chkList = this.menuCheckList.filter((cd:Code) => cd.is_selected == true);
        if(chkList.length == 0) {
            this.menuCheckList.forEach((c: any) => c.is_selected = true);
        }

        this.isShowCheckbox = this.selectedCheckbox;
        this.scaledCarMenuList = this.menuCheckList;
        this.isFirstMenuOpen = false;

        $('#menuMultiSelectModal').modal('hide');
    }


    /**
     * 車両情報詳細モーダルを表示する
     * @param execDiv 処理区分（新規登録、更新）
     */
    carUpdateModalShow(car: Car, execDiv: string = this.CONST.UPDATE) {
        if (execDiv == this.CONST.REGIST) {
            this.clearSelectCar();
            $('#carUpdateModal .modal-title').text('【 車両登録 】');
        } else {
            this.setCurrentCar(car);
            $('#carUpdateModal .modal-title').text('【 車両修正 】');
        }
        $('[href="#nav-home"]').tab('show');  //基本情報tabを初期選択状態とする
        $('#carUpdateModal').modal('show');

        // 所属営業所ドライバーから表示
        const tempList = this.targetDriverList.filter((item)=>item.comp_id == car.comp_id);
        const spliceStart = this.targetDriverList.findIndex(elem=>elem.comp_id==car.comp_id);
        this.targetDriverList.splice(spliceStart, tempList.length);
        this.targetDriverList = tempList.concat(this.targetDriverList);
    }


    /**
     * 選択車両を保存
     * @param car リストから選択した車両Object
     */
    setCurrentCar(car: Car) {
        this.clearCustomError("car_no_last");
        this.clearCustomError("body_no");
        this.clearCustomError("lease_withdrawl");
        this.currentCar = Object.assign({},car);
        this.currentCar.driver_id = car.driver_id ? car.driver_id : 0;

        // 写真ファイルの初期設定
        this.currentCar.car_photos_file = [];
        this.currentCar.car_photos_path = [];
        this.currentCar.car_photos_path_new = [];
        this.setFileDownloadUrl(this.currentCar);
        this.photoPreviewEmptyCnt = this.currentCar.car_photos_path.length >= 12 ? 0 : 12 - this.currentCar.car_photos_path.length;
    }


    setFileDownloadUrl(car: Car) {
        const token: string = sessionStorage.getItem("file_download_token");

        for ( let key in car ) {
            if (key == "car_photos") {
                if (!!car.car_photos) {
                    const photo_path: string[] = car.car_photos.split("|");
                    for (let i=0; i<photo_path.length; i++) {
                        car.car_photos_path.push({
                            idx: i,
                            file_path: photo_path[i],
                            preview_url: this.sanitizer.bypassSecurityTrustResourceUrl(this.BASE_URL + "/common/file-preview/?file_path=" + photo_path[i] + "&token=" + token),
                            is_delete: false
                        });
                    }
                    car.car_photos = undefined;
                }
            }
            // PDFファイルの設定
            // else if (this.carService.PDF_ITEM_NAMES.some((name: string) => name == key)) {
            //     if (car[key]) {
            //         car[key + "_path"] = {
            //             file_path: car[key],
            //             preview_url: this.BASE_URL + "/common/file-preview/?file_path=" + car[key] + "&token=" + token
            //         };
            //         car[key] = undefined;
            //         this.commonService.pdfPreview(car[key+"_path"].preview_url, false, key+"_canvas");
            //     }
            // }

            // (2024.06)複数PDFファイル対応
            else if (this.carService.PDF_ITEM_NAMES.some((name: string) => name == key)) {
            // else if (key == "inspection_pdf") {
                if (car[key]) {
                    car[key+"_path"] = [];
                    const pdf_path: string[] = car[key].split("|");

                    for (let i=0; i<pdf_path.length; i++) {
                        car[key+"_path"][i] = {
                            idx: i,
                            file_path: pdf_path[i],
                            preview_url: this.BASE_URL + "/common/file-preview/?file_path=" + pdf_path[i] + "&token=" + token,
                            // preview_url: this.sanitizer.bypassSecurityTrustResourceUrl(this.BASE_URL + "/common/file-preview/?file_path=" + pdf_path[i] + "&token=" + token),
                            is_delete: false,
                            modal_path: pdf_path[i].slice(pdf_path[i].lastIndexOf('/')+1)
                        }
                        this.commonService.pdfPreview(car[key+"_path"][i].preview_url, false, key+"_canvas"+i.toString());
                    }
                    car[key] = undefined;
                }
            }
        }
    }

    get_photo_path_filter_list() {
        if (this.currentCar.car_photos_path) {
            return this.currentCar.car_photos_path.filter(p => !p.is_delete);
        } else {
            return [];
        }
    }

    get_pdf_path_filter_list(name: string) {
        if (this.currentCar[name + "_path"]) {
            return this.currentCar[name + "_path"].filter(p => !p.is_delete);
        } else {
            return [];
        }
    }


    /**
     * 添付ファイルをプレビュー表示する
     */
    async fileAttach(e: any) {
        const files: File[] = e.target.files;
        const device_info = this.deviceService.getDeviceInfo();

        if (files.length > 0) {
            //PDF選択対象の項目の場合
            if (e.target.accept == "application/pdf") {
                //添付したファイルがPDFである場合
                if (files[0].type == e.target.accept) {
                    this.currentCar[e.target.name + "_file"] = files[0];
                    this.currentCar[e.target.name + "_add_path"] = {
                        preview_url: URL.createObjectURL(files[0]),
                        preview_safeurl: this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[0]) + "#toolbar=0"),
                        new_filename : this.currentCar.car_no_first + this.currentCar.car_no_last + ".PDF"
                    };
                    // this.commonService.pdfPreview(URL.createObjectURL(files[0]), false, e.target.name+"_canvas");
                    this.commonService.pdfPreview(URL.createObjectURL(files[0]), false, e.target.name+"_canvas_add");
                    // this.newFileName = Date.now().toString() + this.currentCar.car_no_first + this.currentCar.car_no_last + ".PDF";
                }
                //添付したファイルがPDFではない場合
                else {
                    this.file_attach_clear(e.target.name);
                    alert("PDFファイルを添付してください。");
                }
            }
            //イメージ選択対象の項目の場合
            else {
                //添付したファイルにJPG, JPEG以外が含まれているか確認
                let is_exist_not_jpg: boolean = false;
                const re = /(?:\.([^.]+))?$/;
                for (let i=0; i<files.length; i++) {
                    const ext: string = (re.exec(files[i].name)[1]).toUpperCase();
                    if (files[i].type != "image/jpeg" || (ext != 'JPG' && ext != 'JPEG')) {
                        is_exist_not_jpg = true;
                        break;
                    }
                }

                //添付したファイルにJPG以外が含まれている場合
                if (is_exist_not_jpg) {
                    this.file_attach_clear(e.target.name);
                    alert("JPG、JPEG形式のファイルを添付してください。");
                } else {
                    for (let i=0; i<files.length; i++) {
                        if (device_info.os.toLowerCase() == "windows") {
                            //イメージサイズ取得
                            let img = new Image();
                            let objectUrl = URL.createObjectURL(files[i]);
                            let img_width = 0;
                            let img_height = 0;
                            img.onload = function () {
                                img_width = img.width;
                                img_height = img.height;
                                URL.revokeObjectURL(objectUrl);
                            };
                            img.src = objectUrl;

                            //イメージリサイズ (img_widthを読み取るために0.2秒timeoutを指定している)
                            setTimeout(async () => {
                                if (img_width > 1600 || img_height > 1600) {
                                    let imageResize;
                                    if (img_width > img_height) {
                                        imageResize = new ImageResize({ width: 1500, format: 'jpg', outputType: "blob" });
                                    } else {
                                        imageResize = new ImageResize({ height: 1500, format: 'jpg', outputType: "blob" });
                                    }
                                    const res = await imageResize.play(files[i]) as Blob;
                                    const f = new File([res], files[i].name, { type: "image/jpeg" });
                                    this.currentCar.car_photos_file.push(f);
                                    this.currentCar.car_photos_path_new.push(this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(f)));
                                } else {
                                    this.currentCar.car_photos_file.push(files[i]);
                                    this.currentCar.car_photos_path_new.push(this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[i])));
                                }
                            }, 200);
                        } else {
                            this.currentCar.car_photos_file.push(files[i]);
                            this.currentCar.car_photos_path_new.push(this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[i])));
                        }
                    }
                    this.photoPreviewEmptyCnt = this.photoPreviewEmptyCnt - (files.length > this.photoPreviewEmptyCnt ? 0 : files.length);
                }
            }
        }
    }


    /**
     * ファイル添付をキャンセル
     * @param target_element_name 対象項目名
     * @param photo_type ファイルタイプ（車両写真の場合のみ使用）
     * @param idx 対象index番号（車両写真の場合のみ使用）
     */
    file_attach_clear(target_element_name: string, photo_type: string = "", idx: number = 0) {
        //車両写真の場合
        if (target_element_name == "car_photos") {
            //既存アップロード済みファイルの場合
            if (photo_type == "old") {
                this.currentCar.car_photos_path[idx].is_delete = true;
            }
            //新規追加したファイル（アップロード前）の場合
            else {
                this.currentCar.car_photos_file.splice(idx, 1);
                this.currentCar.car_photos_path_new.splice(idx, 1);
            }
            this.photoPreviewEmptyCnt = 12 - (this.get_photo_path_filter_list().length + this.currentCar.car_photos_path_new.length);
            this.photoPreviewEmptyCnt = this.photoPreviewEmptyCnt <= 0 ? 0 : this.photoPreviewEmptyCnt;
        }
        //車検証などPDFの場合
        else {
            if (photo_type == "single") {
                this.currentCar[target_element_name] = undefined;
                this.currentCar[target_element_name+"_file"] = undefined;
                this.currentCar[target_element_name+"_add_path"] = undefined;
            }
            else if (photo_type == "old") {
                this.currentCar[target_element_name+"_path"][idx].is_delete = true;
            }
            else {
                this.currentCar[target_element_name] = undefined;
                this.currentCar[target_element_name+"_file"] = undefined;
                this.currentCar[target_element_name+"_path"] = undefined;
            }
        }
    }


    /**
     * 営業所リストを取得
     */
    getBranchList() {
        if (LOGON_INFO.COMP_TYPE == COMP_TYPE.HEAD || LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH) {
            // this.companyService.getCompanyList(1, false, true)
            // .take(1).subscribe(
            //     data => {
            //         this.branchList = data['results'];
            //     }
            // );

            this.scaledBranchList = this.branchList = this.companyService.getCompanyListForCombo();
        }
    }


    //車両番号重複チェック
    isCarNoDuplicate() {
        if (this.carService.isCarnoDuplicate(this.currentCar.car_no_first + this.currentCar.car_no_last, this.currentCar.id)) {
            this.setCustomError("car_no_last");
            return true;
        }
        else {
            this.clearCustomError("car_no_last");
            return false;
        }
    }


    //車台番号重複チェック
    isBodyNoDuplicate() {
        if (this.carService.isBodyNoDuplicate(this.currentCar.body_no, this.currentCar.id)) {
            this.setCustomError("body_no");
            return true;
        }
        else {
            this.clearCustomError("body_no");
            return false;
        }
    }


    isLeaseDate() {
        if (this.currentCar.lease_start_date && this.currentCar.lease_date && this.currentCar.lease_balance && this.currentCar.lease_fee && this.currentCar.lease_withdrawl) {
            // リース開始日、リース満了日、リース残高、リース料/月、リース引落日の全てが入力された場合
            if (this.currentCar.lease_withdrawl < 1 || this.currentCar.lease_withdrawl > 31) {
                this.setCustomError("lease_withdrawl");
                this.messageService.addError("リース引落日は1から31までの数字を入力してください。");
                return true;
            }
            else {
                this.clearCustomError("lease_withdrawl");
                return false;
            }
        } else {
            if (this.currentCar.lease_start_date || this.currentCar.lease_date || this.currentCar.lease_balance || this.currentCar.lease_fee || this.currentCar.lease_withdrawl) {
                // 一部のみ入力された場合
                this.messageService.addError("リース関連項目を全て入力して下さい。");
                return true;
            } else  return false;
        }
    }


    //車両登録
    registCar() {
        if (this.isCarNoDuplicate()) {
            this.messageService.addError("すでに登録済みの車両番号です。");
            return;
        } else if (this.isBodyNoDuplicate())  {
            this.messageService.addError("すでに登録済みの車台番号です。");
            return;
        } else if (this.isLeaseDate()) {
            return;
        }

        this.commonService.showLoading();

        this.carService.registCar(this.currentCar)
            .subscribe(
                data => {
                    this.carService.fetchAllCarList().then(
                        () => {
                            this.messageService.addInfo("「" + this.currentCar.car_no_first + this.currentCar.car_no_last + "」の車両情報が登録されました。");
                            this.refreshPage();
                            this.commonService.hideLoading();
                        }
                    );
                },
                error => {
                    this.commonService.hideLoading();
                }
            );
    }

    //車両更新
    updateCar() {
        if (this.isCarNoDuplicate()) {
            this.messageService.addError("すでに登録済みの車両番号です。");
            return;
        } else if (this.isBodyNoDuplicate())  {
            this.messageService.addError("すでに登録済みの車台番号です。");
            return;
        } else if (this.isLeaseDate()) {
            return;
        }

        this.commonService.showLoading();

        this.carService.updateCar(this.currentCar)
            .subscribe(
                data => {
                    this.carService.fetchAllCarList().then(
                        () => {
                            this.messageService.addInfo("「" + this.currentCar.car_no_first + this.currentCar.car_no_last + "」の車両情報が更新されました。");
                            this.refreshPage();
                            this.commonService.hideLoading();
                        }
                    );
                },
                error => {
                    this.commonService.hideLoading();
                }
            );
    }

    //車両削除（論理削除）
    deleteCar() {
        this.carService.deleteCar(this.currentCar.id)
            .subscribe(
                data => {
                    this.carService.fetchAllCarList().then(
                        () => {
                            this.messageService.addInfo("「" + this.currentCar.car_no_first + this.currentCar.car_no_last + "」が削除されました。");
                            this.refreshPage();
                        }
                    );
                }
            );
    }

    //車両復活
    reviveCar() {
        if (this.carService.isCarnoDuplicate(this.currentCar.car_no, this.currentCar.id)) {
            this.refreshPage();
            this.messageService.addError("すでに登録済みの車両番号です。");
        } else {
            this.carService.reviveCar(this.currentCar.id)
            .subscribe(
                data => {
                    this.carService.fetchAllCarList().then(
                        () => {
                            this.messageService.addInfo("「" + this.currentCar.car_no_first + this.currentCar.car_no_last + "」が復活されました。");
                            this.refreshPage();
                        }
                    );
                }
            );
        }
    }


    //画面リフレッシュ
    refreshPage(): void {
        //車両情報入力欄をクリア
        this.clearSelectCar();

        //車両リストを再読み込み（この更新で他車両の担当ドライバーも変わるため）
        this.getCarList();

        //担当ドライバーcombobox表示用のドライバ－リストを再取得
        this.getDriverList();

        // //jquery内でangular functionを参照するため
        // const component = this;

        $(function() {
            //数字入力欄で最大桁数以上は自動入力不可とする
            $('input[type="number"]').on('input', function() {
                if (this.value.length > this.maxLength) {
                    this.value = this.value.slice(0, this.maxLength);
                }
            });

            // //車両リストの先頭セル以外をclickした場合のevent
            // $('#car-table td:not(:nth-child(1))').on('click', function() {
            //     component.carUpdateModalShow(component.CONST.UPDATE);
            // });
        });
    }


    //入力欄クリア
    clearSelectCar(): void {
        $('#carUpdateModal').modal('hide');
        this.messageService.clearError();
        this.photoPreviewEmptyCnt = 12;

        this.currentCar = new Car();
        // const sd = new Date();
        // this.currentCar.placement_date = { jsdate: sd, formatted: sd.toLocaleDateString() };
        // this.currentCar.inspection_expire_date = { jsdate: sd, formatted: sd.toLocaleDateString() };
        // this.currentCar.driver_id = null;
        this.currentCar.comp_id = "";
        this.currentCar.car_type = "";
        this.currentCar.car_maker = "";
        this.currentCar.driver_id = 0;
        this.currentCar.car_photos_path_new = [];
        this.currentCar.car_photos_file = [];
        this.f.resetForm(this.currentCar);
    }


    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registCar();
                break;
            case "修正":
                this.updateCar();
                break;
            case "削除":
                this.deleteCar();
                break;
            case "復活":
                this.reviveCar();
                break;
        }
    }



    setCustomError(control_name: string) {
        this.f.controls[control_name].setErrors({'custom':true});
        $('#'+control_name).addClass("is-invalid");
    }

    clearCustomError(control_name: string) {
        this.f.controls[control_name].setErrors(null);
        $('#'+control_name).removeClass("is-invalid");
    }



    isExistSelectedCar(): boolean {
        if (this.searchCarList.some((c: Car) => c.is_print_target)) {
            return true;
        } else {
            this.messageService.addInfo("出力対象の車両を選択してください。");
            return false;
        }
    }



    // pdfDownload(item_name: string, file_name: string) {
    //     this.commonService.fileDownload(this.currentCar[item_name + "_path"].file_path, this.currentCar.car_no+'_'+file_name+'.PDF');
    // }
    // 「車両修正」のPDFを押下するとプレビュー画面を表示する
    // pdfPreview(item_name: string, file_name: string) {
    //     this.commonService.filePreviewModalShow(this.currentCar[item_name + "_path"][0].file_path, this.currentCar.car_no+'_'+file_name+'.PDF', "PDF");
    // }
    // (2024.06)配列に対応
    pdfDownload(item_name: string, file_name: string, idx: number) {
        this.commonService.fileDownload(this.currentCar[item_name + "_path"][idx].file_path, this.currentCar.car_no+'_'+file_name+'.PDF');
    }
    pdfPreview(item_name: string, file_name: string, idx: number) {
        this.commonService.filePreviewModalShow(this.currentCar[item_name + "_path"][idx].file_path, this.currentCar.car_no+'_'+file_name+'.PDF', "PDF");
    }



    //////// *
    //////// * (2023.09)PDF出力
    //////// *
    pdfDownloadItemSelectModalShow() {
        if (this.isExistSelectedCar()) {
            this.pdfTarget = new PdfPrintTarget();
            $('#pdfDownloadItemSelectModal').modal('show');
        }
    }



    /**
     * 車検証ダウンロード
     * @param type ダウンロード対象 1:車検証  2:車検証(免許付き)
     */
    downloadInspectionPdf(type: number) {
        if (!this.isExistSelectedCar()) {
            return;
        }

        const path_list: string[] = this.searchCarList
                                        .filter((c: Car) => c.is_print_target && ((type == 1 && c.inspection_pdf) || (type == 2 && c.inspection_license_pdf)))
                                        .map((c: Car) => { return type == 1 ? c.inspection_pdf : c.inspection_license_pdf });

        if (path_list.length == 0) {
            this.messageService.addInfo("車検証が登録されている車両がありません。");
        } else {
            this.commonService.fileDownload(path_list, type == 1 ? "車検証" : "車検証(免許付き)");
        }
    }



    /**
     * 自賠責保険証書ダウンロード
     */
    downloadInsurancePdf() {
        if (!this.isExistSelectedCar()) {
            return;
        }

        const path_list: string[] = this.searchCarList
                                        .filter((c: Car) => c.is_print_target && c.insurance_pdf)
                                        .map((c: Car) => { return c.insurance_pdf });

        if (path_list.length == 0) {
            this.messageService.addInfo("自賠責保険証書が登録されている車両がありません。");
        } else {
            this.commonService.fileDownload(path_list, "自賠責保険証書");
        }
    }



    /**
     * 任意保険証書ダウンロード
     */
    downloadInsuranceOptionPdf() {
        if (!this.isExistSelectedCar()) {
            return;
        }

        const path_list: string[] = this.searchCarList
                                        .filter((c: Car) => c.is_print_target && c.insurance_option_pdf)
                                        .map((c: Car) => { return c.insurance_option_pdf });

        if (path_list.length == 0) {
            this.messageService.addInfo("任意保険証書が登録されている車両がありません。");
        } else {
            this.commonService.fileDownload(path_list, "任意保険証書");
        }
    }



    /**
     * 自重計検査票ダウンロード
     */
    downloadWeightCheckPdf() {
        if (!this.isExistSelectedCar()) {
            return;
        }

        const path_list: string[] = this.searchCarList
                                        .filter((c: Car) => c.is_print_target && c.weight_check_pdf)
                                        .map((c: Car) => { return c.weight_check_pdf });

        if (path_list.length == 0) {
            this.messageService.addInfo("自重計検査票が登録されている車両がありません。");
        } else {
            this.commonService.fileDownload(path_list, "自重計検査票");
        }
    }


    runScheduler() {
        this.commonService.runScheduler();
    }



    // (2023.09)PDF一括ダウンロード
    carListDownloadAsPdf(type: number){
        if (!this.isExistSelectedCar() && !Object.values(this.pdfTarget).includes(true)) {
            return;
        }
        // 直接ダウンロードの場合、待ち時間が１分を超えると504エラー発生
        if (type == 1) {
            if (this.searchCarList.filter((c: Car) => c.is_print_target).length > 100) {
                this.messageService.addError("一括ダウンロードは100件まで選択できます。");
                return;
            }
        }

        // 配列
        const path_list_temp: string[] = this.searchCarList.filter((c: Car) => c.is_print_target).map((c: Car) => {
            let new_list: string = c.car_no;

            if(this.pdfTarget.is_inspection_pdf)            c.inspection_pdf ? new_list += ',' + c.inspection_pdf : null;
            if(this.pdfTarget.is_inspection_license_pdf)    c.inspection_license_pdf ? new_list += ',' + c.inspection_license_pdf : null;
            if(this.pdfTarget.is_insurance_pdf)             c.insurance_pdf ? new_list += ',' + c.insurance_pdf : null;
            if(this.pdfTarget.is_insurance_option_pdf)      c.insurance_option_pdf ? new_list += ',' + c.insurance_option_pdf : null;
            if(this.pdfTarget.is_weight_check_pdf)          c.weight_check_pdf ? new_list += ',' + c.weight_check_pdf : null;

            return new_list != c.car_no ? new_list : null;
        })

        const path_list: string[] = path_list_temp.filter(elem => elem != null);

        let condition: string = '';
        if(this.selectedBranch)         condition += this.selectedBranch;
        if(this.selectedCarMaker)       condition += (condition ? '/' : null) + this.selectedCarMaker;
        if(this.selectedCarType)        condition += (condition ? '/' : null) + this.selectedCarType;
        if(this.selectedRegistYear)     condition += (condition ? '/' : null) + this.selectedRegistYear;
        if(this.selectedExistDriver)    condition += (condition ? '/' : null) + this.selectedExistDriver;

        if (path_list.length == 0) {
            this.messageService.addInfo("条件に合わせる車両がありません。");
        } else {
            type == 1 ? this.commonService.fileDownload(path_list, "車両別PDF") : this.commonService.fileDownload(path_list, "車両別Link", condition);
        }
    }


    //////// *
    //////// * EXCEL出力
    //////// *
    excelPrintItemSelectModalShow() {
        if (this.isExistSelectedCar()) {
            this.printTarget = new ExcelPrintTarget();
            $('#excelPrintItemSelectModal').modal('show');
        }
    }

    // carListExportAsExcel() {
    //     if (!this.isExistSelectedCar()) {
    //         return;
    //     }

    //     const title: any[] = [];

    //     // (2023.07) Sorting by car_type
    //     const tempCarList:Car[] = [...this.searchCarList];
    //     tempCarList.sort((a:Car,b:Car)=>{
    //         if(a.car_type > b.car_type)     return 1;
    //         if(a.car_type < b.car_type)     return -1;
    //         return 0;
    //     })

    //     const targetCarList = tempCarList
    //     .filter((c: Car) => c.is_print_target)
    //     .map((c: Car, index: number) => {
    //         const new_car: any[] = [];
    //         if (this.printTarget.is_index_print)                         { if(index==0) title.push({v: "連番", t: "s"});              new_car.push({ t: "n", v: index+1 }) };
    //         if (this.printTarget.is_car_type_print)                      { if(index==0) title.push({v: "車種", t: "s"});              new_car.push({ t: "s", v: c.car_type_name.replace('ダンプ','') }) };
    //         if (this.printTarget.is_car_no_print)                        { if(index==0) title.push({v: "車両番号", t: "s"});          new_car.push({ t: "s", v: c.car_no_first + c.car_no_last }) };
    //         if (this.printTarget.is_max_load_weight_print)               { if(index==0) title.push({v: "最大積載量", t: "s"});        new_car.push({ t: "n", v: c.max_load_weight, s: { numFmt: "0,00" } }) };
    //         if (this.printTarget.is_car_weight_print)                    { if(index==0) title.push({v: "車両重量空車", t: "s"});      new_car.push({ t: "n", v: c.car_weight, s: { numFmt: "0,00" }}) };
    //         if (this.printTarget.is_inspection_expire_date_print)        { if(index==0) title.push({v: "車検満了日", t: "s"});        new_car.push({ t: "d", v: c.inspection_expire_date ? c.inspection_expire_date.formatted : null }) };
    //         if (this.printTarget.is_driver_print)                        { if(index==0) title.push({v: "ドライバー名", t: "s"});          new_car.push({ t: "s", v: c.driver_name }) };
    //         if (this.printTarget.is_driver_license_type_print)           { if(index==0) title.push({v: "免許種類", t: "s"});          new_car.push({ t: "s", v: c.driver_license_type ? this.licenseList.find(elem => elem.code == c.driver_license_type).name : null }) };

    //         if (this.printTarget.is_driver_license_expire_date_print)    { if(index==0) title.push({v: "免許証有効期限", t: "s"});    new_car.push({ t: "d", v: c.driver_license_expire_date }) };
    //         if (this.printTarget.is_driver_tel_print)                    { if(index==0) title.push({v: "電話番号", t: "s"});          new_car.push({ t: "s", v: c.driver_tel }) };
    //         if (this.printTarget.is_car_maker_print)                     { if(index==0) title.push({v: "車名", t: "s"});              new_car.push({ t: "s", v: c.car_maker_name }) };
    //         if (this.printTarget.is_model_no_print)                      { if(index==0) title.push({v: "型式", t: "s"});              new_car.push({ t: "s", v: c.model_no }) };
    //         if (this.printTarget.is_regist_ym_print)                     { if(index==0) title.push({v: "初度登録年月", t: "s"});      new_car.push({ t: "s", v: c.regist_ym }) };

    //         if (this.printTarget.is_group_name_print)                    { if(index==0) title.push({v: "会社", t: "s"});              new_car.push({ t: "s", v: c.group_name }) };
    //         if (this.printTarget.is_comp_name_print)                     { if(index==0) title.push({v: "所属", t: "s"});              new_car.push({ t: "s", v: c.comp_name }) };
    //         if (this.printTarget.is_placement_date_print)                { if(index==0) title.push({v: "配置日", t: "s"});            new_car.push({ t: "d", v: c.placement_date ? c.placement_date.formatted : null }) };
    //         if (this.printTarget.is_body_no_print)                       { if(index==0) title.push({v: "車台番号", t: "s"});          new_car.push({ t: "s", v: c.body_no }) };
    //         if (this.printTarget.is_insurance_expire_date_print)         { if(index==0) title.push({v: "自賠責期日", t: "s"});        new_car.push({ t: "d", v: c.insurance_expire_date ? c.insurance_expire_date.formatted : null }) };
    //         if (this.printTarget.is_owner_print)                         { if(index==0) title.push({v: "所有者", t: "s"});            new_car.push({ t: "s", v: c.owner }) };
    //         if (this.printTarget.is_lease_date_print)                    { if(index==0) title.push({v: "リース満了日", t: "s"});        new_car.push({ t: "d", v: c.lease_date ? c.lease_date.formatted : null }) };
    //         if (this.printTarget.is_bed_size_print)                      { if(index==0) title.push({v: "荷台サイズ", t: "s"});        new_car.push({ t: "s", v: (c.depth ? c.depth : 0)+" ×  "+(c.width ? c.width : 0) + " × "+(c.height ? c.height : 0) }) };
    //         if (this.printTarget.is_etc_print)                           { if(index==0) title.push({v: "備考", t: "s"});              new_car.push({ t: "s", v: c.etc }) };
    //         return new_car;
    //     });

    //     targetCarList.unshift(title);

    //     let excelFilename: string = "車両台帳";
    //     if (this.search_comp_id) {
    //         excelFilename += "_" + this.branchList.find((c: Company) => c.comp_id == this.search_comp_id).name;
    //     }

    //     this.commonService.printCarListExcel(targetCarList, excelFilename);
    // }

    // (2023.08) Use new library (ExcelJS)
    carListExportAsExcelJs() {
        if (!this.isExistSelectedCar()) {
            return;
        }

        // (2023.08) Sorting
        // const tempCarList: Car[] = [...this.searchCarList];
        // tempCarList.sort((a: Car,b: Car)=>{
        //     if(a.car_type > b.car_type)     return 1;
        //     if(a.car_type < b.car_type)     return -1;
        //     return 0;
        // })

        // (2023.09) Change sorting
        const printCarList: Car[] = [];
        this.carTypeCodeList.forEach((cd: Code) => {
            this.searchCarList.filter((cf: Car) => cf.car_type == cd.code).map((cm: Car) => printCarList.push(cm));
        });

        const title: any[] = [];
        const columnStyle = {
            style: { font: {size: 10, name:'メイリオ' }, alignment: { shrinkToFit: true }, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }
        };

        const targetCarList = printCarList.filter((cf: Car) => cf.is_print_target).map((cm: Car, index: number) => {
            const new_car: any[] = [];

            if (this.printTarget.is_index_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '連番', key: 'index', width: 5 });
                new_car.push(index+1);
            }
            if (this.printTarget.is_car_type_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '車種', key: 'car_type', width: 19 });
                new_car.push(cm.car_type_name.replace('ダンプ','')) };
            if (this.printTarget.is_car_no_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '車両番号', key: 'car_no', width: 14 });
                new_car.push(cm.car_no_first +cm.car_no_last);
            }
            if (this.printTarget.is_max_load_weight_print) {
                if(index == 0)      title.push({ header: '最大積載量', key: 'max_load_weight', width: 10, style: { font: {size: 10, name:'メイリオ'}, numFmt: '0,00', alignment: { shrinkToFit: true}, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }});
                new_car.push(cm.max_load_weight);
            }
            if (this.printTarget.is_car_weight_print) {
                if(index == 0)      title.push({ header: '車両重量空車', key: 'car_weight', width: 11, style: { font: {size: 10, name:'メイリオ'}, numFmt: '0,00', alignment: { shrinkToFit: true}, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }});
                new_car.push(cm.car_weight);
            }
            if (this.printTarget.is_inspection_expire_date_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '車検満了日', key: 'inspection_expire_date', width: 10 });
                new_car.push(cm.inspection_expire_date ?cm.inspection_expire_date.formatted : null);
            }
            if (this.printTarget.is_driver_print) {
                if(index == 0)      title.push({ ...columnStyle, header: 'ドライバー名', key: 'driver', width: 17 });
                new_car.push(cm.driver_name);
            }
            if (this.printTarget.is_driver_license_type_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '免許種類', key: 'driver_license_type', width: 8 });
                new_car.push(cm.driver_license_type ? this.licenseList.find(elem => elem.code ==cm.driver_license_type).name : null);
            }
            if (this.printTarget.is_driver_license_expire_date_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '免許証有効期限', key: 'driver_license_expire_date', width: 13 });
                new_car.push(cm.driver_license_expire_date);
            }
            if (this.printTarget.is_driver_tel_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '電話番号', key: 'driver_tel', width: 13 });
                new_car.push(cm.driver_tel);
            }
            if (this.printTarget.is_car_maker_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '車名', key: 'car_maker', width: 7 });
                new_car.push(cm.car_maker_name);
            }
            if (this.printTarget.is_model_no_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '型式', key: 'model_no', width: 13 });
                new_car.push(cm.model_no);
            }
            if (this.printTarget.is_regist_ym_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '初度登録年月', key: 'regist_ym', width: 11 });
                new_car.push(cm.regist_ym);
            }

            if (this.printTarget.is_group_name_print)
            {
                if(index == 0)      title.push({ ...columnStyle, header: '会社', key: 'group_name', width: 5 });
                new_car.push(cm.group_name);
            }
            if (this.printTarget.is_comp_name_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '所属', key: 'comp_name', width: 16 });
                new_car.push(cm.comp_name);
            }
            if (this.printTarget.is_placement_date_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '配置日', key: 'placement_date', width: 10 });
                new_car.push(cm.placement_date ?cm.placement_date.formatted : null);
            }
            if (this.printTarget.is_body_no_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '車台番号', key: 'body_no', width: 20 });
                new_car.push(cm.body_no);
            }
            if (this.printTarget.is_insurance_expire_date_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '自賠責期日', key: 'insurance_expire_date', width: 10 });
                new_car.push(cm.insurance_expire_date ?cm.insurance_expire_date.formatted : null);
            }
            if (this.printTarget.is_owner_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '所有者', key: 'is_owner_print', width: 20 });
                new_car.push(cm.owner);
            }

            // (202404)リース料関連項目追加
            if (this.printTarget.is_lease_start_date_print) {
                if(index == 0)      title.push({ ...columnStyle, header: 'リース開始日', key: 'lease_start_date', width: 11 });
                new_car.push(cm.lease_start_date ?cm.lease_start_date.formatted : null);
            }
            if (this.printTarget.is_lease_date_print) {
                if(index == 0)      title.push({ ...columnStyle, header: 'リース満了日', key: 'lease_date', width: 11 });
                new_car.push(cm.lease_date ?cm.lease_date.formatted : null);
            }
            if (this.printTarget.is_lease_balance_print) {
                if(index == 0)      title.push({ header: 'リース残高', key: 'lease_balance', width: 10, style: { font: {size: 10, name:'メイリオ'}, numFmt: '0,00', alignment: { shrinkToFit: true}, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }});
                new_car.push(cm.lease_balance);
            }
            if (this.printTarget.is_lease_fee_print) {
                if(index == 0)      title.push({ header: 'リース料/月', key: 'lease_fee', width: 10, style: { font: {size: 10, name:'メイリオ'}, numFmt: '0,00', alignment: { shrinkToFit: true}, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }});
                new_car.push(cm.lease_fee);
            }
            if (this.printTarget.is_lease_withdrawl_print) {
                if(index == 0)      title.push({ header: 'リース引落日', key: 'lease_withdrawl', width: 10, style: { font: {size: 10, name:'メイリオ'}, alignment: { shrinkToFit: true}, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }});
                new_car.push(cm.lease_withdrawl);
            }
            if (this.printTarget.is_lease_disposal_print) {
                if(index == 0)      title.push({ header: 'リース残価', key: 'lease_disposal', width: 10, style: { font: {size: 10, name:'メイリオ'}, numFmt: '0,00', alignment: { shrinkToFit: true}, border: { top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}} }});
                new_car.push(cm.lease_disposal);
            }

            if (this.printTarget.is_bed_size_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '荷台サイズ', key: 'bed_size', width: 14 });
                new_car.push((cm.depth ? cm.depth : 0) + " × "+(cm.width ? cm.width : 0) + " × " + (cm.height ? cm.height : 0));
            }
            if (this.printTarget.is_etc_print) {
                if(index == 0)      title.push({ ...columnStyle, header: '備考', key: 'etc', width: 30 });
                new_car.push(cm.etc);
            }

            return new_car;
        });

        let excelFilename: string = "車両台帳";
        if (this.search_comp_id) {
            excelFilename += "_" + this.branchList.find((c: Company) => c.comp_id == this.search_comp_id).name;
        }

        this.commonService.printCarListExcelJs(title, targetCarList, excelFilename);
    }
    //////// *

    //////// *
    //////// * (2024.01)マルチセレクト検索
    //////// *
    carMultiSelectModalShow(title: string) {
        this.selectedCategory = title;

        if(title == "所属")     this.selectedCheckList = this.scaledBranchList;
        if(title == "車種")     this.selectedCheckList = this.scaledCarTypeCodeList;
        if(title == "車名")     this.selectedCheckList = this.scaledCarMakerCodeList;
        if(title == "年式")     this.selectedCheckList = this.scaledCarRegistYearList;
        if(title == "有無")     this.selectedCheckList = this.scaledExistDriverList;

        // (2026.04) 日本語辞書順（あいうえお順）にソートを行い、項目の位置を固定する
        // 年式(Year)は、ユーザーの要望により既存の年度順序（時系列）を維持するため除外する
        if (title !== "年式") {
            this.selectedCheckList.sort((a: any, b: any) => (a.name || "").localeCompare(b.name || "", 'ja-JP'));
        }

        if (this.isFirstSearchMap[title] || !this.selectedCheckList.some((l: any) => l.is_selected === false)) {
            this.selectedCheckList.forEach((l: any) => l.is_selected = false);
        }

        // (2026.04) モーダル内でキャンセル時、以前の状態に戻すため元の状態を保存
        this.savedSelectionState = this.selectedCheckList.map((l: any) => l.is_selected);

        $('#carMultiSelectModal').modal('show');
        $('#carMultiSelectModal .modal-title').text('【 ' + title + '選択 】');
        $('#carMultiSelectModal .modal-dialog')

        // if (this.isExistSelectedCar()) {
        //     this.printTarget = new ExcelPrintTarget();
        //     $('#carMultiSelectModal').modal('show');
        // }
    }
    //////// *

    //////// *
    //////// * (2024.04)メニュー項目選択
    //////// *
    menuMultiSelectModalShow() {
        this.menuCheckList = [];
        this.selectedCheckbox = this.isFirstMenuOpen ? false : this.isShowCheckbox;
        this.menuCheckList = JSON.parse(JSON.stringify(this.scaledCarMenuList));    // Deep copy

        if (this.isFirstMenuOpen || !this.menuCheckList.some((l: any) => l.is_selected === false)) {
            this.menuCheckList.forEach((l: any) => l.is_selected = false);
        }

        $('#menuMultiSelectModal').modal('show');
        $('#menuMultiSelectModal .modal-dialog');
    }
    //////// *

    //////// *
    //////// * (2024.04)画面印刷の機能追加
    //////// *
    screenPrint() {
        this.commonService.showLoading();

        // 案１：htmlそのまま印刷する方法
        const newWindow = window.open("", "_blank");

        newWindow.document.write("<head>"+document.head.innerHTML+"</head>");
        newWindow.document.write("<body>"+document.getElementById('screenPrint').innerHTML+"</body>");
        newWindow.document.close();

        newWindow.print();
        newWindow.close();


        // 案２：イメージ生成後、印刷する方法
        // html2canvas(document.querySelector("#screenPrint")).then(canvas => {
        //     this.printImg(canvas.toDataURL('image/jpg'));
        // }).catch((e: any) => {
        //     this.messageService.addError("イメージ生成に失敗しました。");
        // });

        this.commonService.hideLoading();
    }

    printImg = (uri) => {
        const prtImg = new Image();

        prtImg.src = uri;

        const prtWindow  = window.open("", '_blank');
        prtWindow.document.open();
        prtWindow.document.write('<img src="' + prtImg.src + '" alt="" style="width: 100%; height: auto;">');

        const selectBody = prtWindow.document.querySelector("body");
        selectBody.style.margin = '0';

        setTimeout(() => {
            prtWindow.print();
        },100);
    }

    //////// *
    //////// * (2024.05)ダウンロードリンク確認モーダル
    //////// *
    // ダウンロードリンクの確認
    async pdfDownloadLinkModalShow() {
        await this.carService.getPdfLinkList();

        this.commonService.showLoading();
        this.pdfLinkList = JSON.parse(sessionStorage.getItem("pdf_link"));
        this.linkCount = this.pdfLinkList.length;


        $('#pdfDownloadLinkModal').modal('show');
        this.commonService.hideLoading();
    }

    // ダウンロードリンクのコピー
    copyDownloadLink() {
        const copyText = document.getElementById("linkCopy").innerText;

        if(copyText.length > 1) {
            let clipboard = new ClipBoard('#copyLink');
            clipboard.on('success', function(e) {
                e.clearSelection();
            })

            this.messageService.addInfo("ダウンロードリンクがコピーされました。");
        } else  this.messageService.addError("コピーが出来るダウンロードリンクが存在しません。");

    }


    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }
}



// WEBPACK FOOTER //
// ./src/app/member-kanri/car.component.ts